/**
 * @classdesc Japanese Language Pack
 * @desc This class will used to translate tokens into the Japanese language.
 * @namespace Languages.Japanese
 */

/**
 * @constant dictionary
 * @type {object}
 * @memberof Languages.Japanese
 */
export const dictionary = {
	'years'   : '年',
	'months'  : '月',
	'days'    : '日',
	'hours'   : '時',
	'minutes' : '分',
	'seconds' : '秒'
};

/**
 * @constant aliases
 * @type {array}
 * @memberof Languages.Japanese
 */
export const aliases = ['jp', 'ja-jp', 'japanese'];
